import React, { PropTypes } from 'react';
import '../../styles/ObservationScores';
import moment from 'moment';
import { Link } from 'react-router';
import _ from 'lodash';

let ObservationScores = React.createClass({
	propTypes: {
		fetchObservations: PropTypes.func.isRequired,
		isFetchingObservations: PropTypes.bool,
		isScoringObservation: PropTypes.bool,
		observations: PropTypes.array,
		reliabilityScores: PropTypes.object,
		params: PropTypes.shape({
			observationId: PropTypes.string.isRequired
		}),
	},

	getInitialState: function() {
		return {
			goldStandardObservation: null,
			scoredObservation: null
		};
	},

	componentWillMount: function() {
		this.props.fetchObservations().then(() => {
			this.setObservationsInState(this.props);
		});
	},

	componentDidMount: function() {
		window.addEventListener('resize', this.updateDurationTimelineWidth);
	},

	componentDidUpdate: function() {
		if (this.getDurationTimelineWidth() !== this.state.durationTimelineWidth) {
			this.updateDurationTimelineWidth();
		}
	},

	componentWillUnmount: function() {
		window.removeEventListener('resize', this.updateDurationTimelineWidth);
	},

	timelineColors: [
		'#000000', // black
		'#FF6600', // orange
		'#669900', // green
		'#0066CC', // blue
		'#CC00CE', // purple
		'#FF9C00', // lighter orange
		'#9893FF', // lavender
		'#006d1f', // dark green
		'#FF93A7', // salmon
		'#aa2929', // dark red
		'#42c2f5', // baby blue
	],

	updateDurationTimelineWidth: function() {
		this.setState({ durationTimelineWidth: this.getDurationTimelineWidth() });
	},

	getDurationTimelineWidth: function() {
		return $('.duration-timeline-container').first().width() - $('.timeline-type').first().width();
	},

	setObservationsInState: function(props) {
		let scoredObservation = this.getObservationById(props.params.observationId, props.observations);

		if (scoredObservation) {
			let goldStandardObservation = this.getObservationById(
				scoredObservation.gold_standard_observation_id,
				props.observations
			);

			this.setState({
				scoredObservation: scoredObservation,
				goldStandardObservation: goldStandardObservation
			}, () => {
				props.scoreObservation(
					this.state.scoredObservation.id,
					this.state.goldStandardObservation.id
				);
			});
		}
	},

	getObservationById: function(observationID, observations = null) {
		if (observations === null) {
			observations = this.props.observations;
		}

		let observation = null;

		observations.every((thisObservation) => {
			if (thisObservation.id === parseInt(observationID)) {
				observation = thisObservation;
				return false;
			} else {
				return true;
			}
		});

		return observation;
	},

	buildTimelines: function(heading, intervalKey, intervals, maxSeconds) {
		let pixelsPerSecond = this.state.durationTimelineWidth / maxSeconds;

		return (
			<div className="duration-timeline-container">
				<h4>{ heading }</h4>
				{
					this.buildTimelineLegend(intervals[intervalKey].scored.concat(intervals[intervalKey].gold_standard))
				}
				<div className="duration-timeline">
					<div className="timeline-type">Scored</div>
					{ this.buildTimeline(intervals[intervalKey].scored, pixelsPerSecond) }
				</div>
				<div className="duration-timeline">
					<div className="timeline-type">Gold</div>
					{ this.buildTimeline(intervals[intervalKey].gold_standard, pixelsPerSecond) }
				</div>
				{ this.buildTimelineLabels(intervals[intervalKey].gold_standard) }
			</div>
		);
	},

	buildTimeline: function(intervals, pixelsPerSecond) {
		if (intervals.asMutable) {
			intervals = intervals.asMutable();
		}
		let totalSeconds = 0;
		intervals.map((interval) => totalSeconds += interval.total_seconds);

		return intervals.map((interval, index) => {
			return (
				<div
					className="timeline-segment"
					style={ {
						width: (interval.total_seconds * pixelsPerSecond) + 'px',
						backgroundColor: this.timelineColors[interval.numeric_value]
					} }
					key={ 'interval-'  + index + '-' + Math.random() }
				/>
			);
		});
	},

	buildTimelineLabels: function(intervals) {
		if (intervals.asMutable) {
			intervals = intervals.asMutable();
		}
		let totalSeconds = 0;
		intervals.map((interval) => totalSeconds += interval.total_seconds);
		// We get a few lost / extra seconds in the observations.  For example, a 3-minute student
		// observation period might result in a total of 176 or 184 seconds.  I'm not really sure why,
		// but to compensate, I'm rounding to the nearest multiple of 60 here.
		totalSeconds = Math.round(totalSeconds / 60) * 60;
		let numberOfLabels = Math.floor(totalSeconds / 30) + 1;
		return (
			<div className="timeline-labels">
				{
					[...Array(numberOfLabels)].map((e, i) => {
						return (
							<span className="timeline-label" key={ 'timeline-label-' + i + '-' + Math.random() }>
								{ moment('2015-01-01').startOf('day').seconds(i * 30).format('m:ss') }
							</span>
						);
					})
				}
			</div>
		);
	},

	buildTimelineLegend: function(intervals) {
		let values = [];
		if (intervals.asMutable) {
			intervals = intervals.asMutable();
		}
		intervals.map((interval) => values[interval.numeric_value] = interval.readable_value);

		return (
			<div className="timeline-legend">
				{
					Object.keys(values).sort().map((numericValue) => {
						let readableValue = values[numericValue];
						return (
							<div className="timeline-legend-item" key={ 'timeline-legend-item-' + Math.random() }>
								<div
									className="timeline-legend-color"
									style={ { backgroundColor: this.timelineColors[numericValue] } }
								/>
								<div className="timeline-legend-label">{ readableValue }</div>
							</div>
						);
					})
				}
			</div>
		);
	},

	render: function() {
		let { scoredObservation, goldStandardObservation } = this.state,
			reliabilityScores = this.props.reliabilityScores.asMutable(),
			teacherScores,
			maxTeacherSeconds;

		if (this.props.reliabilityScores && this.props.reliabilityScores.duration) {
			teacherScores = this.props.reliabilityScores.duration.teacher;
			maxTeacherSeconds = Math.max(teacherScores.gold_standard_seconds, teacherScores.scored_seconds);
		}

		return(
			<div className="observation-scores container">
				<h2>Observation Reliability Scores</h2>
				{
					!scoredObservation || this.props.isScoringObservation || this.props.isFetchingObservations ? (
						<div className="scoring-observation">
							Please wait while this observation is scored...{' '}
							<i className="glyphicon glyphicon-spin glyphicon-refresh" />
						</div>
					) : (
						!!scoredObservation && this.props.reliabilityScores && Object.keys(this.props.reliabilityScores).length ? (
							<div className="reliability-scores">
								<div className="observation-info">
									<div className="observation-highlights">
										<p>{ scoredObservation.classroom.description } observed by { scoredObservation.observer_name }</p>
										<p>Recorded on { moment(scoredObservation.observation_date).format('dddd, MMMM Do YYYY') }</p>
										<p>Observed on { moment(scoredObservation.created_at).format('dddd, MMMM Do YYYY') }</p>
									</div>

									<div className="observation-parameter">
										<span className="parameter-name">Teacher: </span>
										<span className="parameter-value">{ scoredObservation.teacher.name }</span>
									</div>

									<div className="observed-students">
										<span className="parameter-name">Students observed: </span>
										<span className="parameter-value">
											{
												scoredObservation.students.asMutable().map((student, index) => {
													return (
														student.first_name + ' ' + student.last_name
													);
												}).join(', ')
											}
										</span>
									</div>

									<div className="gold-standard-info">
										The gold standard observation for this recording was performed on { moment(goldStandardObservation.created_at).format('dddd, MMMM Do YYYY') } by { goldStandardObservation.observer_name }.
									</div>
								</div>
								<div className="score-category frequency">
									{
										this.state.scoredObservation && this.state.scoredObservation.student_minutes > 0 ? (
											<div>
												<h3 className="score-heading">
											Student Frequency: <span className="overall-score">{ reliabilityScores.frequency.average_student_score }%</span>
												</h3>
												{
													reliabilityScores.frequency.students.asMutable().map((studentScores, index) => {
														return (
															<div className="scores-by-student" key={ 'student-scores-' + index }>
																<h4>{ studentScores.student_name }: <span className="student-score">{ studentScores.score }%</span></h4>
																<table
																	key={ 'student-frequency-' + index }
																	className="table table-striped table-condensed"
																>
																	<thead>
																		<tr>
																			<th>Move type</th>
																			<th>Gold standard moves</th>
																			<th>Scored moves</th>
																			<th>Threshold</th>
																			<th>Score</th>
																		</tr>
																	</thead>
																	<tbody>
																		{
																			studentScores.moves.asMutable().map((moveData, index) => {
																				return (
																					<tr key={ 'student-moves-' + index }>
																						<td className="event-type">{ moveData.description }</td>
																						<td>{ moveData.gold_standard_total }</td>
																						<td>{ moveData.scored_total }</td>
																						<td>{ moveData.reliability_threshold }</td>
																						<td className="student-score">{ moveData.score }%</td>
																					</tr>
																				);
																			})
																		}
																	</tbody>
																</table>
															</div>
														);
													})
												}
											</div>
										) : ''
									}
									{
										this.state.scoredObservation && this.state.scoredObservation.teacher_minutes > 0 ? (
											<div className="scores-by-student">
												<h3 className="score-heading">
												Teacher Frequency: <span className="overall-score">{ reliabilityScores.frequency.teacher.score }%</span>
												</h3>
												<table className="table table-striped table-condensed">
													<thead>
														<tr>
															<th>Move type</th>
															<th>Gold standard moves</th>
															<th>Scored moves</th>
															<th>Threshold</th>
															<th>Score</th>
														</tr>
													</thead>
													<tbody>
														{
															reliabilityScores.frequency.teacher.moves.asMutable().map((moveData, index) => {
																return (
																	<tr key={ 'teacher-moves-' + index }>
																		<td className="event-type">{ moveData.description }</td>
																		<td>{ moveData.gold_standard_total }</td>
																		<td>{ moveData.scored_total }</td>
																		<td>{ moveData.reliability_threshold }</td>
																		<td className="student-score">{ moveData.score }%</td>
																	</tr>
																);
															})
														}
													</tbody>
												</table>
											</div>
										) : ''
									}
								</div>
								<div className="score-category duration">
									<h3 className="score-heading">
										Duration: <span className="overall-score">{ reliabilityScores.duration.score }%</span>
									</h3>
									<table className="table table-striped">
										<thead>
											<tr>
												<th></th>
												<th>Score</th>
											</tr>
										</thead>
										<tbody>
											{
												this.state.scoredObservation && this.state.scoredObservation.teacher_minutes > 0 ? (
													<tr>
														<td className="student-name">Teacher</td>
														<td className="student-score">{ reliabilityScores.duration.teacher.score }%</td>
													</tr>
												) : null
											}
											{
												this.state.scoredObservation && this.state.scoredObservation.student_minutes > 0 ? (
													reliabilityScores.duration.students.asMutable().map((studentScores, index) => {
														return (
															<tr key={ 'duration-' + index }>
																<td className="student-name">{ studentScores.student_name }</td>
																<td className="student-score">{ studentScores.score }%</td>
															</tr>
														);
													})
												) : null
											}
										</tbody>
									</table>
									<div className="duration-timelines">
										<h2>Duration Code Timelines</h2>
										{
											this.state.scoredObservation && this.state.scoredObservation.student_minutes > 0 ? (
												reliabilityScores.duration.students.asMutable().map((studentScores, index) => {
													let { intervals } = studentScores;
													let maxSeconds = Math.max(studentScores.scored_seconds, studentScores.gold_standard_seconds);

													return (
														<div key={ 'student-duration-' + index } className="student-duration-timelines">
															<h3>{ studentScores.student_name }</h3>
															{ this.buildTimelines('Subject', 'subject', intervals, maxSeconds) }
															{ this.buildTimelines('Context', 'context', intervals, maxSeconds) }
															{ this.buildTimelines('Management', 'management', intervals, maxSeconds) }
															{ this.buildTimelines('Instruction Type', 'instruction_type', intervals, maxSeconds) }
															{ this.buildTimelines('Behavior', 'behavior', intervals, maxSeconds) }
														</div>
													);
												})
											) : ''
										}
										{
											this.state.scoredObservation && this.state.scoredObservation.teacher_minutes > 0 ? (
												<div>
													<h3>Teacher</h3>
													{ this.buildTimelines('Subject', 'subject', reliabilityScores.duration.teacher.intervals.asMutable(), maxTeacherSeconds) }
													{ this.buildTimelines('Context', 'context', reliabilityScores.duration.teacher.intervals.asMutable(), maxTeacherSeconds) }
													{ this.buildTimelines('Management', 'management', reliabilityScores.duration.teacher.intervals.asMutable(), maxTeacherSeconds) }
													{ this.buildTimelines('Instruction Type', 'instruction_type', reliabilityScores.duration.teacher.intervals.asMutable(), maxTeacherSeconds) }
												</div>
											) : ''
										}
									</div>
								</div>
							</div>
						) : ''
					)
				}
				<Link className="btn btn-lg btn-default" to="/">Back to menu</Link>
			</div>
		);
	}
});

module.exports = ObservationScores;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/ObservationScores.jsx